import styled from 'styled-components';
import styleUtils from '../../../styles/style.utils';
import themedColor from '../../../styles/theme/themed-color';
import mediaBreakpoints from '../../../styles/media-breakpoints';
import Text from '../text/text';
import themedFontSize from '../../../styles/theme/themed-font-size';

const Container = styled.div`
  width: 100%;
  min-height: ${styleUtils.size('HEADER_HEIGHT')};
  display: flex;
  margin-bottom: ${styleUtils.px(16)};
`;

const LeftBox = styled.div`
  background: ${themedColor('HEADER_BG')};
  width: calc((100% - ${styleUtils.size('MAX_CONTAINER_WIDTH')}) / 2);
`;

const MainColumn = styled.div`
  max-width: calc(
    ${styleUtils.size('MAX_CONTAINER_WIDTH')} + ${styleUtils.px(32)}
  );
  display: flex;
  flex: 1;
`;

interface TextContainerProps {
  isFormPage?: boolean;
}

const TextContainer = styled.div<TextContainerProps>`
  background: ${themedColor('HEADER_BG')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: ${styleUtils.px(16)} ${styleUtils.px(65)} ${styleUtils.px(16)}
    ${styleUtils.px(16)};
  flex-basis: 100%;

  ${mediaBreakpoints.greaterThan<TextContainerProps>('M')`   
    border-radius: 0 ${styleUtils.size(
      'HEADER_BORDER_RADIUS'
    )} ${styleUtils.size('HEADER_BORDER_RADIUS')} 0;
  `};
`;

const StyledText = styled(Text)`
  &.ucf-paragraph {
    color: ${themedColor('TEXT_BLUE')};
    ${mediaBreakpoints.greaterThan('M')`    
    margin-right: 30%;
    max-width: 100%;
  `};
  }
`;
const Title = styled(StyledText)`
  &.ucf-paragraph {
    font-size: ${themedFontSize('HEADER_TITLE_M')};
    font-weight: 700;
    margin-bottom: ${styleUtils.px(4)};

    ${mediaBreakpoints.greaterThan('XS')`    
    font-size: ${themedFontSize('HEADER_TITLE')};
  `};
  }
`;
const Content = styled(StyledText)<TextContainerProps>`
  &.ucf-paragraph {
    font-size: ${themedFontSize('HEADER_CONTENT')};
    font-weight: 400;
    ${mediaBreakpoints.greaterThan<TextContainerProps>('M')` 
      white-space: pre;
     `};
  }
`;

const HeaderComponents = {
  Container,
  LeftBox,
  MainColumn,
  TextContainer,
  Title,
  Content
};
export default HeaderComponents;
